import axios from "axios";
import { GridColDef,GridRenderCellParams,GridEditSingleSelectCellProps,GridEditSingleSelectCell } from '@mui/x-data-grid';
import moment from 'moment';
import CheckCircle from "@mui/icons-material/CheckCircle";
import "i18n/config";
import i18next from "i18next";

export const get = async (row?:any) => {
    let organization = localStorage.getItem('currentOrganization');
    let response = await axios.get(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/assessment/organization/"+organization);
    return response.data;
};

export const update = async (row:any) => {
    let response = null;
    let organization = localStorage.getItem('currentOrganization');
    if(!row.id) {
        response = await axios.post(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/assessment/organization/"+organization+"/store",row);
    } else {
        response = await axios.post(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/assessment/organization/"+organization+"/update/"+row.id,row);
    }
    return response.data;
};

export const destroy = async (id:any) => {
    let response = null;
    let organization = localStorage.getItem('currentOrganization');
    response = await axios.post(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/assessment/organization/"+organization+"/delete/"+id);
    return response.data;
};

export async function getStatus(organization_id:string, assessment_id: string) {
  let response = await axios.get(process.env.REACT_APP_WISEVIEW_BACKEND_URL+ "/assessment/organization/"+organization_id+"/status/"+assessment_id);
  return response.data;
}

export async function getScore(row?:any) {
  let organization = localStorage.getItem('currentOrganization');
  let assessment = localStorage.getItem('currentAssessment');
  if(!organization || !assessment) return new Promise((resolve, reject) => {resolve([])});
  let response = await axios.get(process.env.REACT_APP_WISEVIEW_BACKEND_URL+ "/assessment/organization/"+organization+"/score/"+assessment);
  return response.data;
}

export async function getColumns(locale:string) {
  i18next.changeLanguage(locale);
  return [
    { 
      field: 'id', 
      headerName: 'ID', 
      width: 90 
    },
    {
      field: 'name',
      headerName: i18next.t('Name'),
      flex: 1,
      editable: true,
    },
    {
      field: 'id_owner',
      headerName: i18next.t('Owner'),
      flex: 1,
      editable: true,
      type: 'singleSelect',
      valueOptions: [],
      valueGetter: params => params.row.id_owner || '',
    },
    {
      field: 'fncs',
      headerName: 'FNCS',
      flex: 1,
      editable: true,
      type: "singleSelect",
      valueOptions: [
        { value: 1, label: 'Yes' },
        { value: 0, label: 'No' }
      ],
      // New rows have no value yet: FNCS is on by default (matches the backend default).
      valueGetter: params => params.row.fncs ?? 1,
      renderCell: (params: GridRenderCellParams<any, Date>) => params.value ? <CheckCircle /> : '',
      renderEditCell: (params: GridEditSingleSelectCellProps) => {
        return !params.row.id ? <GridEditSingleSelectCell {...params} /> : params.row.fncs ? <CheckCircle sx={{color:'#666', marginLeft:1}} /> : '';
      },
    },
    {
      field: 'gdpr',
      headerName: 'GDPR',
      flex: 1,
      editable: true,
      type: "singleSelect",
      valueOptions: [
        { value: 1, label: 'Yes' },
        { value: 0, label: 'No' }
      ],
      valueGetter: params => params.row.gdpr || '',
      valueFormatter: params => params?.value ? <CheckCircle /> : '',
      renderCell: (params: GridRenderCellParams<any, Date>) => params.value ? <CheckCircle /> : '',
      renderEditCell: (params: GridEditSingleSelectCellProps) => {
        return !params.row.id ? <GridEditSingleSelectCell {...params} /> : params.row.gdpr ? <CheckCircle sx={{color:'#666', marginLeft:1}} /> : '';
      },
    },    
    {
      field: 'psnc',
      headerName: 'PSNC',
      flex: 1,
      editable: true,
      type: "singleSelect",
      valueOptions: [
        { value: 1, label: 'Yes' },
        { value: 0, label: 'No' }
      ],
      valueGetter: params => params.row.psnc || '',
      valueFormatter: params => params?.value ? <CheckCircle /> : '',
      renderCell: (params: GridRenderCellParams<any, Date>) => params.value ? <CheckCircle /> : '',
      renderEditCell: (params: GridEditSingleSelectCellProps) => {
        return !params.row.id ? <GridEditSingleSelectCell {...params} /> : params.row.psnc ? <CheckCircle sx={{color:'#666', marginLeft:1}} /> : '';
      },
    },
    {
      field: 'nis2_subject_type',
      headerName: i18next.t('NIS2'),
      flex: 1,
      editable: true,
      type: "singleSelect",
      valueOptions: [
        { value: '', label: i18next.t('None') },
        { value: 'essenziale', label: i18next.t('Essential') },
        { value: 'importante', label: i18next.t('Important') },
      ],
      valueGetter: params => params.row.nis2_subject_type || '',
      renderEditCell: (params: GridEditSingleSelectCellProps) => {
        return !params.row.id ? <GridEditSingleSelectCell {...params} /> : params.row.nis2_subject_type || '';
      },
    },  
    {
      field: 'created_at',
      headerName: i18next.t('Created'),
      type: 'date',
      valueGetter: params => moment(params.row.created_at).toDate(),
      valueFormatter: params => new Date(params?.value).toLocaleString(),
      flex: 1,
      maxWidth: 250,
      editable: false,
    }
  ] as GridColDef[]
};